export default __webpack_public_path__ + "static/media/project_lg_autopartes_3.65d47df0.png";